// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.primary {
  color: #108757 !important; }

#ListItem {
  background-color: #fff; }

#Loading {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 999999999999;
  background-color: rgba(255, 255, 255, 0.95); }
  #Loading .lds-ring {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px; }
  #Loading .lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 4px solid #FFBE00;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #FFBE00 transparent transparent transparent; }
  #Loading .lds-ring div:nth-child(1) {
    animation-delay: -0.45s; }
  #Loading .lds-ring div:nth-child(2) {
    animation-delay: -0.3s; }
  #Loading .lds-ring div:nth-child(3) {
    animation-delay: -0.15s; }

@keyframes lds-ring {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

#Steps {
  width: 100%;
  height: calc(100vh - 64px - 75px); }
  #Steps .step-lefts {
    position: fixed;
    height: 100%; }

#Tags {
  border-color: #108757; }
  #Tags .tag {
    color: #108757;
    background-color: rgba(16, 135, 87, 0.12); }
  #Tags .x {
    width: 14px;
    height: 14px;
    line-height: 13px;
    font-size: 12px;
    text-align: center;
    background-color: rgba(16, 135, 87, 0.32);
    border-radius: 45px;
    display: inline; }
`, "",{"version":3,"sources":["webpack://./src/assets/scss/variables.scss","webpack://./src/components/Ui/_Ui.scss"],"names":[],"mappings":"AAGA;EACI,yBAA0B,EAAA;;ACF9B;EACI,sBAAsB,EAAA;;AAG1B;EACI,eAAe;EACf,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,2CAAmC,EAAA;EALvC;IAQQ,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,YAAY,EAAA;EAXpB;IAeQ,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,8DAA8D;IAC9D,yDAAyD,EAAA;EAxBjE;IA4BQ,uBAAuB,EAAA;EA5B/B;IAgCQ,sBAAsB,EAAA;EAhC9B;IAoCQ,uBAAuB,EAAA;;AAG3B;EACI;IACI,uBAAuB,EAAA;EAG3B;IACI,yBAAyB,EAAA,EAAA;;AAMrC;EACI,WAAW;EACX,iCAAiC,EAAA;EAFrC;IAKQ,eAAe;IACf,YAAY,EAAA;;AAUpB;EACI,qBD1Ea,EAAA;ECyEjB;IAIQ,cD7ES;IC8ET,yCD9ES,EAAA;ECyEjB;IASQ,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,yCDvFS;ICwFT,mBAAmB;IACnB,eAAe,EAAA","sourcesContent":["$primary: #108757;\n$secondary: #979797;\n\n.primary {\n    color: $primary !important;\n}","@import '../../assets/scss/variables.scss';\n\n#ListItem {\n    background-color: #fff;\n}\n\n#Loading {\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    z-index: 999999999999;\n    background-color: rgba($color: #fff, $alpha: .95);\n\n    .lds-ring {\n        display: inline-block;\n        position: relative;\n        width: 80px;\n        height: 80px;\n    }\n\n    .lds-ring div {\n        box-sizing: border-box;\n        display: block;\n        position: absolute;\n        width: 64px;\n        height: 64px;\n        margin: 8px;\n        border: 4px solid #FFBE00;\n        border-radius: 50%;\n        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n        border-color: #FFBE00 transparent transparent transparent;\n    }\n\n    .lds-ring div:nth-child(1) {\n        animation-delay: -0.45s;\n    }\n\n    .lds-ring div:nth-child(2) {\n        animation-delay: -0.3s;\n    }\n\n    .lds-ring div:nth-child(3) {\n        animation-delay: -0.15s;\n    }\n\n    @keyframes lds-ring {\n        0% {\n            transform: rotate(0deg);\n        }\n\n        100% {\n            transform: rotate(360deg);\n        }\n    }\n\n}\n\n#Steps {\n    width: 100%;\n    height: calc(100vh - 64px - 75px);\n\n    .step-lefts {\n        position: fixed;\n        height: 100%;\n    }\n\n    // .step-right {\n    //     overflow: hidden;\n    //     overflow-y: scroll;\n       \n    // }\n}\n\n#Tags {\n    border-color: $primary;\n\n    .tag {\n        color: $primary;\n        background-color: rgba($color: $primary, $alpha: .12);\n    }\n\n    .x {\n        width: 14px;\n        height: 14px;\n        line-height: 13px;\n        font-size: 12px;\n        text-align: center;\n        background-color: rgba($color: $primary, $alpha: .32);\n        border-radius: 45px;\n        display: inline;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
